<script>
// Load component libraries and components
import Group from "./../primitives/Group.svelte";
import Textline from "./../primitives/Textline.svelte";
import Input from "./../primitives/Input.svelte";

// Load libraries, modules and others


// Set model 
// Set css props
// Set css variables 
export let label = "Etiqueta";
export let align = "left";
export let size = "1em";
export let margin = "0em 0em 0.5em 0em";
export let textSize = size;
textSize = parseFloat(textSize);
export let labelSize = textSize*0.8;
labelSize = parseFloat(labelSize);
export let color = "#FFFFFF"
export let weight = 600;
export let placeholder = "";
export let w = "auto";
export let value = text || "";
export let type = "text";
export let background
export let inputColor

// Set methods


// Other logic

</script>



<Group layout="column" >
    <Textline text="{label}" size="{labelSize}em" {color} {weight} margin="0em 0em 0.5em 0em" {align} {w}></Textline>
    <Input {type} {placeholder} {align} {margin} {w} {background} color={inputColor} bind:value={value}/>
</Group>